import React, { useEffect, useState } from 'react';
import style from './style.module.css'
import { Input, TextArea } from '../../components/inputs';
import { Button } from '../../components/buttons';
import { ContactCard } from '../../components/cards';
import {
  LinksConnectedToUsIcon,
  OurOfficeIcon,
  SendUsMailIcon,
  TalkWithUsIcon
} from '../../assets';
import { Link } from 'react-router-dom';
import axios from 'axios'
import Alert from '../../components/alert'

const url = "https://alpha3.norlics.ng/api/norlicsDigitalMsg/message"

const ContactUs = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    emailAddress: '',
    message: ''
  });


  const [alert, setAlert] = useState({
    showing: false,
    type: null,
    message: ""
  });

  const handleInputUpate = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value })
  }
  
  const handleFormSubmition = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);

    if (Object.values(formData).includes('')) {
      setAlert({
        showing: true,
        type: "error",
        message: "All fields are required."
      });
      setLoading(false);
      return;
    }

    axios.post(url, formData)
      .then((response) => {
        setFormData({
          firstName: '',
          lastName: '',
          phoneNumber: '',
          emailAddress: '',
          message: ''
        })

        setAlert({
          showing: true,
          type: "success",
          message:
            response?.data?.message ??
            "Successful!"
        });
      })
      .catch((error) => {
        setAlert({
          showing: true,
          type: "error",
          message:
            error?.response?.data?.errors?.details[0]?.message ??
            "There was an error. Please try again!"
        });
      })
      .finally(() => {
        setLoading(false);
      })
  }

  useEffect(() => {
    const delay = setTimeout(
      () =>
        setAlert({
          showing: false,
          type: null,
          message: ""
        }),
      3000
    );

    return () => clearTimeout(delay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!!alert.showing]);

  return (
    <>
      {alert.showing && <Alert text={alert.message} type={alert.type} />}
      <main>
        <section className={style.get__in__touch}>
          <div className={style.get__in__touch_wrapper}>
            <h2>Get in touch</h2>
            <p>Please enter the details of your request. A member of our support staff will respond as soon as possible.</p>
            <form onSubmit={handleFormSubmition}>
              <div className={style.double__input}>
                <div>
                  <Input
                    label='First name'
                    fieldName='firstName'
                    value={formData.firstName}
                    onChange={handleInputUpate}
                  />
                </div>
                <div>
                  <Input
                    label='Last name'
                    fieldName='lastName'
                    value={formData.lastName}
                    onChange={handleInputUpate}
                  />
                </div>
              </div>
              <div className={style.double__input}>
                <div>
                  <Input
                    label='Email Address'
                    fieldName='emailAddress'
                    value={formData.emailAddress}
                    onChange={handleInputUpate}
                  />
                </div>
                <div>
                  <Input
                    label='Phone number'
                    fieldName='phoneNumber'
                    value={formData.phoneNumber}
                    onChange={handleInputUpate}
                  />
                </div>
              </div>
              <div>
                <TextArea
                  label='Message'
                  fieldName='message'
                  value={formData.message}
                  row={2}
                  onChange={handleInputUpate}
                />
              </div>
              <Button
                disabled={loading}
                children={loading ? 'Submitting...' : 'Submit'}
              />
            </form>
          </div>
        </section>
        <section className={style.reach__out}>
          <div className={style.reach__out_wrapper}>
            <h2>Reach out to us</h2>
            <p>This are the other means to reach out to us today about anything.</p>
            <div className={style.reach__out_cards}>
              <Link to={"https://www.google.com/maps/place/Fidelity+Estate,+32+Prince+Paul+Nnaji+Cres,+GRA,+Enugu+400102,+Enugu/@6.45636,7.50005,1968m/data=!3m1!1e3!4m6!3m5!1s0x1044a3c101f0940d:0x4fcb555640065015!8m2!3d6.4563604!4d7.5000495!16s%2Fg%2F11hd1yct4x?hl=en&entry=ttu&g_ep=EgoyMDI0MTAwOS4wIKXMDSoASAFQAw%3D%3D"}>
                <ContactCard
                  Icon={OurOfficeIcon}
                  header='Our Office'
                  description="Plot O, Trinity House, Apartment B, Fidelity Estate, Okpara Avenue, Enugu"
                />
              </Link>
              <ContactCard
                Icon={TalkWithUsIcon}
                header='Talk With Us'
                description={<>Call or Whatsapp: <a href='tel:+2347063162705'>+2347063162705</a></>}
              />
              <ContactCard
                Icon={SendUsMailIcon}
                header='Send Us a Mail Today'
                description={<a href='mailto:norlics@norlics.com.ng'>norlics@norlics.com.ng</a>}
              />
              <ContactCard
                Icon={LinksConnectedToUsIcon}
                header='Links Connected To Us'
                description={<>JTB: www.Jtblink.com <br />IRS: <a href='https://www.irs.en.gov.ng'>www.irs.en.gov.ng</a></>}
              />
            </div>
          </div>
        </section>
        <section className={style.contact__map}>
          <iframe title='googleMap' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4460.078308149859!2d7.497474575499415!3d6.456360393535159!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1044a3c101f0940d%3A0x4fcb555640065015!2sFidelity%20Estate%2C%2032%20Prince%20Paul%20Nnaji%20Cres%2C%20GRA%2C%20Enugu%20400102%2C%20Enugu!5e1!3m2!1sen!2sng!4v1726840434274!5m2!1sen!2sng" width="600" height="500" style={{ width: '100%' }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
        </section>
      </main>
    </>
  )
}

export default ContactUs